import React from 'react'
import { IconButton, Icon } from 'rsuite'

export default function DownloadButton({ onClick, children = 'ดาวน์โหลด', disabled, ...props }) {
  return (
    <IconButton
      appearance="ghost"
      style={{
        marginRight: 10,
        marginBottom: 10,
      }}
      onClick={onClick}
      icon={<Icon appearance="ghost" icon="download" className="bt-gost-icon-radius" />}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  )
}
